import React from "react";
import { updateOtaArtifact } from "../../commonApi";
import { extractErrorMessage, extractSuccessMessage } from "../../Utils/ExtractMessages";
import { toast } from "react-toastify";
import { getArtifactFormFields } from "./ArtifactFormFieldsConfig";
import DynamicForm from "../../components/DynamicForm";

export const UpdateArtifactModal = ({ isOpen, onClose, artifact, deviceModels, onSuccess }) => {
    if (!isOpen || !artifact) return null;

    const allFields = getArtifactFormFields(deviceModels, null, "edit");

    const fields = allFields.filter(
        (field) => field.name !== "file"
    );

    const defaultValues = {
        artifactName: artifact.artifactName,
        version: artifact.version,
        deviceModelId: {
            label: artifact.deviceModelName,
            value: artifact.deviceModelId
        },
        artifactType: {
            label: artifact.artifactType,
            value: artifact.artifactType
        },
        releaseChannel: {
            label: artifact.releaseChannel,
            value: artifact.releaseChannel
        },
        fileSizeBytes: artifact.fileSizeBytes,
        checksum: artifact.checksum,
        isConsentRequired: artifact.isConsentRequired
    };

    const handleSubmit = async (values) => {
        try {
            const payload = {
                releaseChannel: values.releaseChannel?.value,
                isConsentRequired: values.isConsentRequired
            };

            const response = await updateOtaArtifact(artifact.id, payload);

            toast.success(extractSuccessMessage(response, "Artifact updated successfully"));

            onClose();
            onSuccess();
        } catch (error) {
            const msg = extractErrorMessage(error)
            if (error?.response?.status === 404) {
                toast.warn(msg);
                onClose();
                onSuccess();
                return;
            }
            toast.error(msg);
        }
    };

    return (
        <div className="artifact-modal-overlay">
            <div className="artifact-modal-container">
                <div className="artifact-modal-header" style={{ color: "#4340d2" }}>
                    <h4>Edit Artifact</h4>
                    <button type="button" className="btn-close" onClick={onClose} />
                </div>

                <div className="artifact-modal-body">
                    <DynamicForm
                        formClass="artifact-form"
                        fields={fields}
                        defaultValues={defaultValues}
                        onSubmit={handleSubmit}
                        onClose={onClose}
                        disabledFields={["artifactName", "version", "deviceModelId", "artifactType", "file", "fileSizeBytes", "checksum"]}
                    />
                </div>
            </div>
        </div>
    );
};
